"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegralIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ChartContext_1 = require("../../context/ChartContext");
const formatNumber_1 = require("../../utility/formatNumber");
const styles = {
    text: {
        fontSize: '11px',
        fill: 'black',
    },
    path: {
        fill: 'none',
        strokeWidth: '1px',
        shapeRendering: 'crispEdges',
        stroke: 'black',
    },
};
function IntegralIndicator(props) {
    const { value, width, format, opacity = 1 } = props;
    const { height, margin } = (0, ChartContext_1.useChartData)();
    const bottom = height - margin.bottom;
    return ((0, jsx_runtime_1.jsxs)("g", { transform: `translate(0 ${bottom - 10})`, style: { opacity }, children: [(0, jsx_runtime_1.jsx)("text", { transform: `rotate(-90) translate(5 ${Math.round(width / 2) + 4})`, style: styles.text, children: value ? (0, formatNumber_1.formatNumber)(value, format) : '' }), (0, jsx_runtime_1.jsx)("path", { style: styles.path, d: `M0 0 L0 5 L${width} 5 L${width} 0 ` })] }));
}
exports.IntegralIndicator = IntegralIndicator;
